export default __webpack_public_path__ + "static/media/chrome-tab-dark.a2bf3627.webp";